import 'reflect-metadata';
import 'styles/main.scss';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import { JobillaDesignSystem } from '@jobilla/jobilla-design-system';
Vue.use(VueMeta);
Vue.use(JobillaDesignSystem);
import JobillaSpaApplication from 'common/JobillaSpaApplication';
// Views
import CompanyPrivacyPolicyView from './views/CompanyPrivacyPolicyView.vue';
import MainApp from './TermsApp.vue';
import { JobillaApplication } from 'packages/core/JobillaApplication';
import store from 'store/public/index';
import { QuillScope } from 'packages/core/DeltaRenderer';
import axios from 'axios';
import env from 'config/env';
var app = new JobillaSpaApplication(false);
app.appName = 'terms';
app.languageService.setAppType('spa-public');
app.withStore(store);
axios.defaults.baseURL = env.JOBILLA_API_ROOT;
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
// Map the settings app to the main app component in index.html
app.registerComponents({
    MainApp: MainApp,
});
app.configureRoutes([
    {
        path: '/:lang/:companyId',
        name: 'Company.PrivacyPolicy',
        component: CompanyPrivacyPolicyView,
        props: function (route) { return ({
            companyId: parseInt(route.params.companyId),
        }); },
    },
    {
        path: '/',
        beforeEnter: function () {
            window.location.replace('https://jobilla.com/en/legal');
        },
    },
]);
app.start(false);
new JobillaApplication().boot({
    quillScope: QuillScope.PUBLIC,
    withIntercom: true,
});
